import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { Container, Row } from "../admin/styles";
import AdminNavbar from "../../components/Navbar/index";
import Footer from "../../components/Footer/index";
import Sidebar from "../../components/Sidebar/index";
import routes from "../../routes/pix.routes";
import mainRouteInterface from "../../routes/interfaces/mainRouteInterface"

const PayOrder = (): React.ReactElement => (
  <Row>
    <Sidebar />
    <Container>
      <AdminNavbar />
      <Switch>
        {
          routes.map((prop: mainRouteInterface, key: number): React.ReactElement => {
            return (
              <Route
                path={`/admin${prop.layout}${prop.path}`}
                component={prop.component}
                key={key}
              />
            );
          })
        }
        <Redirect from="*" to="/admin/pix/payment-link" />
      </Switch>
      <Footer />
    </Container>
  </Row>
);

export default PayOrder;
